'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'staff', 'staffFilters', 'def',
    function ($scope, $modalInstance, staff, staffFilters, def) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.isSelect = isSelect;

        init();

        // region Function

        // инициализация модели
        function init() {
            $scope.staff = angular.copy(staff);
            $scope.filters = angular.copy(staffFilters);
            $scope.def = angular.copy(def);
        }

        function ok(staff) {
            $modalInstance.close(staff);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function isSelect() {
            return $scope.staff != null && $scope.staff.id != null;
        }

        // endregion
    }];
